/* eslint-disable jsx-a11y/role-supports-aria-props */
import React from "react";

const TabToggle = ({ activeTab, handleTabClick, data }) => {
  return (
    <ul className="content-tabs">
      {data?.map((item, i) => {
        return (
          <li className="nav-item" key={i}>
            <button
              className={`nav-link ${activeTab === item ? "active" : ""}`}
              type="button"
              onClick={() => handleTabClick(item)}
            >
              {item}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default TabToggle;
